(() => {
  const wrapperSelector =
    '#main-cart-footer.cart-page-figma .cart__dynamic-checkout-buttons.cart-wallet-pending';
  const walletSelector = 'shopify-accelerated-checkout-cart';
  const skeletonSelector = '.wallet-cart-grid--skeleton, .wallet-cart-button__skeleton';
  const preparedAttribute = 'data-cart-wallet-prepared';
  const fallbackDelay = 2500;

  const reveal = (wrapper) => {
    if (!wrapper?.isConnected) return;

    wrapper.classList.remove('cart-wallet-pending');
    wrapper.classList.add('cart-wallet-ready');
    wrapper.removeAttribute('aria-busy');

    if (wrapper.cartWalletObserver) {
      wrapper.cartWalletObserver.disconnect();
      delete wrapper.cartWalletObserver;
    }

    if (wrapper.cartWalletFallback) {
      window.clearTimeout(wrapper.cartWalletFallback);
      delete wrapper.cartWalletFallback;
    }
  };

  const walletIsReady = (wallet) => {
    if (!wallet?.isConnected || wallet.querySelector(skeletonSelector)) return false;

    const bounds = wallet.getBoundingClientRect();
    return bounds.width > 0 && bounds.height > 0;
  };

  const prepare = (wrapper) => {
    if (!(wrapper instanceof HTMLElement) || wrapper.hasAttribute(preparedAttribute)) return;

    wrapper.setAttribute(preparedAttribute, 'true');
    const wallet = wrapper.querySelector(walletSelector);

    if (!wallet) {
      reveal(wrapper);
      return;
    }

    let checkFrame;
    const check = () => {
      window.cancelAnimationFrame(checkFrame);
      checkFrame = window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          if (walletIsReady(wallet)) reveal(wrapper);
        });
      });
    };

    wrapper.cartWalletObserver = new MutationObserver(check);
    wrapper.cartWalletObserver.observe(wallet, { childList: true, subtree: true });
    wrapper.cartWalletFallback = window.setTimeout(() => reveal(wrapper), fallbackDelay);

    if (window.customElements?.whenDefined) {
      window.customElements.whenDefined(walletSelector).then(check).catch(() => {});
    }

    check();
  };

  const scan = (root = document) => {
    if (root instanceof Element && root.matches(wrapperSelector)) prepare(root);
    root.querySelectorAll?.(wrapperSelector).forEach(prepare);
  };

  const revealPreparedWallets = () => {
    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        document.querySelectorAll(wrapperSelector).forEach(reveal);
      });
    });
  };

  scan();

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) scan(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify:payment_button:loaded', revealPreparedWallets);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
